import { useState, useCallback } from 'react';
import type { ReportsFilters } from '@/services/reports.service';

export interface DrillDownFilters {
  statusName?: string;
  inspectionTypeName?: string;
  providerId?: string;
  city?: string;
  month?: string;
  year?: number;
  startDate?: string;
  endDate?: string;
  inspectionType?: string;
}

interface UseDrillDownProps {
  getEffectiveFilters?: () => ReportsFilters;
}

export function useDrillDown({ getEffectiveFilters }: UseDrillDownProps = {}) {
  const [isDrillDownModalOpen, setIsDrillDownModalOpen] = useState(false);
  const [drillDownTitle, setDrillDownTitle] = useState('');
  const [drillDownFilters, setDrillDownFilters] = useState<DrillDownFilters>({});

  const openDrillDown = useCallback((title: string, filters: DrillDownFilters) => {
    
    
    const mergedFilters: DrillDownFilters = getEffectiveFilters
      ? {
          ...getEffectiveFilters(),  
          ...filters,                
        }
      : { ...filters };  

    setDrillDownTitle(title);
    setDrillDownFilters(mergedFilters);
    setIsDrillDownModalOpen(true);
  }, [getEffectiveFilters]);

  const closeDrillDown = useCallback(() => {
    setIsDrillDownModalOpen(false);
    setDrillDownTitle('');
    setDrillDownFilters({});
  }, []);

  
  const handleStatusDrillDown = useCallback((statusName: string) => {
    openDrillDown(`Vistorias com Status: ${statusName}`, { statusName });
  }, [openDrillDown]);

  const handleInspectionTypeDrillDown = useCallback((typeName: string) => {
    openDrillDown(`Vistorias do Tipo: ${typeName}`, { inspectionTypeName: typeName });
  }, [openDrillDown]);

  const handleProviderDrillDown = useCallback((providerId: string, providerName: string) => {
    openDrillDown(`Vistorias da Prestadora: ${providerName}`, { providerId });
  }, [openDrillDown]);

  const handleCityDrillDown = useCallback((city: string, state: string) => {
    openDrillDown(`Vistorias em ${city}-${state}`, { city });
  }, [openDrillDown]);

  const handleMonthDrillDown = useCallback((month: string, year: number) => {
    openDrillDown(`Vistorias de ${month}/${year}`, { month, year });
  }, [openDrillDown]);

  return {
    
    isDrillDownModalOpen,
    drillDownTitle,
    drillDownFilters,

    
    openDrillDown,
    closeDrillDown,


    handleStatusDrillDown,
    handleInspectionTypeDrillDown,
    handleProviderDrillDown,
    handleCityDrillDown,
    handleMonthDrillDown,
  };
}
